import template from './drainage.jade';
import suburbanDrainageType from '../../../enums/suburban-drainage-type';

export default angular.module('cian.addForm.commonDrainage', []).directive('cianAfCommonDrainage', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    function () {
      this.suburbanDrainageTypeOptions = suburbanDrainageType;

      const isUnknownType = typeof this.ad.hasDrainage === 'undefined' || this.ad.hasDrainage;

      if (isUnknownType && this.ad.drainage?.type) {
        this.value = this.ad.drainage.type;
      } else if (this.ad.hasDrainage === false && !this.ad.drainage?.type) {
        this.value = 'no';
      }

      const updateDrainageValue = ({ type, hasDrainage }) => {
        const drainage = type ? { ...this.ad.drainage, type } : undefined;

        this.ad = {
          ...this.ad,
          drainage,
          hasDrainage,
        };
      };

      this.handleChange = () => {
        const drainageValue =
          this.value === 'no'
            ? { hasDrainage: false }
            : { type: this.value, hasDrainage: this.ad.hasDrainage || undefined };

        updateDrainageValue(drainageValue);
      };
    },
  ],
  controllerAs: 'drainage',
  template,
})).name;
